import moment from 'moment'
import TitleBar from './title_bar.coffee'
import Application from '../loopback_api.coffee'
import * as crashReporter from '../crash_reporter.coffee'
import {retryAbortedRead} from '../transition_recovery.coffee'
import {createShellRouter, startReact, renderReactError, parseUrl, normalizeRoute} from '../shell.coffee'
import {routes, guards} from './routes.coffee'
import {decodeRedirectParams, routeHash} from '../deep_link.coffee'
import {patchPlaybackResourceHandoff, patchWebAudioDecodeRejection} from '../sound_playback_patch.coffee'
import {isUnauthenticatedDeepLink} from '../Login/unauthenticated_routes.coffee'
import {servesBootRead, signOutToSignIn} from '../dead_session.coffee'
import { hide_agent_widget } from '../common.coffee'
import ClientAPI from  "../../../../../schema/framework/shared/client_api.coffee"
import {i18nCreateElement, initI18n, I18nRegistry, t} from '../../../../../schema/framework/shared/i18n/index.coffee'

# createjs 1.0.0 hands a freshly loaded buffer to the instances waiting for it
# with a method that release does not have, and throws instead (card
# 6aab65a36c29c3a6dc3bbbb7). Patched HERE, at module scope in the webpack entry,
# because AbstractPlugin.register captures the handler as the loader's complete
# listener — a sound registered before this call would keep the broken one.
patchPlaybackResourceHandoff()

# And createjs 1.0.0's WebAudioLoader drops the promise decodeAudioData returns,
# so a clip WebKit cannot decode is an unhandled EncodingError and the child's
# say() never finishes (card 6ab1f98bcb41c3b4ffd4bd76). Same reason for the same
# placement: the loader class is captured when a sound is registered.
patchWebAudioDecodeRejection()

params = parseUrl window.location.href

clientAPI = new ClientAPI(window.config.basePath || '', "/clientapi", "$teacher$")
# WHOSE LINK WAS THIS — card 6aaf07728b7b7297d73a152b. A boot crash on a link
# whose token cannot authenticate has no session and, on a device that never
# signed in here, no remembered identity either — so the CrashLog row names
# nobody. The URL does. Recorded before anything can throw, and ranked below
# both real sources: it is what a link claimed, not somebody who signed in.
crashReporter.noteAttemptedIdentityFromUrlParams params

# Pre-set auth from URL params before loading schema.
# Without this, arriving at /teacher with no $teacher$ token in localStorage
# causes loadSchema() to run unauthenticated, returning a partial schema that
# is missing teacher-specific models and methods.
if params.access_token? && !clientAPI.isLoggedIn()
  clientAPI.setUser(params.access_token, params.uid, undefined, params.studentId)
  clientAPI.resetAuthHeader()
# THE SCHEMA LOAD IS A BOOT READ TOO — card 6abc395ba68734bf39cc263d. It is the
# first request the page makes, before the crash reporter or window.app exist, and
# an aborted GET /clientapi on a LIVE page (axios 'Request aborted'; axios-retry does
# not retry ECONNABORTED) rejected with no .catch: the child sat on "Loading App..."
# for good and nothing was reported. Reproduced on the QA bundle by aborting
# /clientapi; 37 activities-run loads ended this way on 2026-09-29. Same retry,
# same judgment as the account read below.
retryAbortedRead((-> clientAPI.loadSchema()), (error) ->
  console.warn "Schema load was aborted (#{error?.message ? error}) — retrying"
).then () ->
  crashReporter.install('teacher')   # card 6aad7bb96e6a1e18a090353b: crashes report themselves
  window.app = new Application(clientAPI)

  # Make i18n functions globally available for lazy-loaded chunks
  window.i18nCreateElement = i18nCreateElement
  window.t = t

  hide_agent_widget() if window.app.isApp()

  # The router, its hooks (transition recovery, the route-change upgrade, the
  # i18n context), the React root and the boot-error screen are the three
  # shells' shared code (../shell.coffee, card 6ac022cba664bc34d57be8c3).
  router = createShellRouter routes, {otherwise: 'teacherDashboard', guards, label: 'teacher', contextPrefix: 'elfeet/teacher/'}

  start_react = -> startReact router

  render_react_error = (error) -> renderReactError error

  initialize = (route_to='teacher_dashboard', route_params={}) ->
    window.application_running = 'teacher'
    # THE BOOT READ IS NOT MADE ON A MANIFEST THAT DOES NOT SERVE IT — card
    # 6ab69fbe027287c485001e30.
    #
    # `isLoggedIn()` is true whenever a token sits under `$teacher$`; it says
    # nothing about what the manifest in hand will serve. When `/clientapi`
    # answered 200 with the anonymous manifest — which it does for a presented
    # token that authorizes to no usable role, not only for no token at all —
    # `refresh()` below called `Account.getAccount`, which is not on it, and
    # threw SYNCHRONOUSLY into `render_react_error` and the ErrorBoundary.
    # Production CrashLog 4d62018a, /teacher#/tokens, 2026-09-25.
    #
    # A session this shell cannot read is not a session. Same landing as the
    # dead-token case: drop it and show sign-in, which is the screen the person
    # actually needs, instead of a crash screen with no way forward.
    unless servesBootRead window.app?.loopbackAPI
      console.warn "This session's API does not serve Account.getAccount — signing out to the sign-in screen"
      return signOutToSignIn start_react
    # ONE RETRY ON AN ABORTED BOOT READ — card 6aab772ced72ee7fceb166f3. This
    # read runs before the router exists, so transition_recovery's onError hook
    # is not installed yet and cannot catch it. This shell had no .catch here at
    # all, so a single transient abort was an unhandled rejection: nothing
    # rendered, no message, a blank page.
    retryAbortedRead((-> window.app.refresh()), (error) ->
      console.warn "App boot read was aborted (#{error?.message ? error}) — retrying once"
    ).then (response) ->
      if response.data?.login? # we did not fetch account data, send them to login screen...
        # Initialize i18n with user's preferred language
        preferredLang = response.data.login.preferredLanguage || response.data.login.preferred_language || 'en'
        # console.log "Initializing i18n with preferred language: #{preferredLang}"
        initI18n(clientAPI, preferredLang)

        # Set moment locale for date formatting and month names
        if preferredLang and !preferredLang.startsWith('en')
          momentLang = preferredLang.split('-')[0].toLowerCase()
          import("moment/locale/#{momentLang}")
            .then -> moment.locale(momentLang)
            .catch -> console.warn "moment locale #{momentLang} not available"

        # Fetch all translations before navigating so first render is already translated
        # 'en-US' is not 'en': ask the framework whether this locale reads the
        # authored text before fetching the catalogue (card 6aa6c73847c945dd8596e7d9).
        if !window.i18nManager.readsSource()
          await clientAPI.i18nString.find({where: {app: 'elfeet'}}).then (resp) ->
            cache = {}
            strings = if Array.isArray(resp) then resp else (resp?.data || [])
            for string in strings
              cache[string.hash] = string.text
            try
              localStorage.setItem("i18n_#{preferredLang}_elfeet", JSON.stringify(cache))
              window.i18nTranslationCache ?= {}
              for hash, text of cache
                window.i18nTranslationCache[hash] = text
            catch e
              console.warn "Failed to cache teacher translations:", e

        # Initialize i18n registry
        window.i18nRegistry = new I18nRegistry(clientAPI)
        # Strip query parameters from route for cleaner tracking
        routeWithoutQuery = window.location.hash.split('?')[0]
        normalizedRoute = normalizeRoute(routeWithoutQuery)
        window.i18nRegistry.setContext('elfeet/teacher/init', normalizedRoute, 'elfeet')

        # Make i18n utilities globally available
        window.i18nCreateElement = i18nCreateElement
        window.t = t

        # A SESSION IS NEVER KEPT ON A PORTAL ITS OWN MANIFEST CANNOT RENDER —
        # card 6ab01ff71c823bb5a74a1ed7, the same reading as card
        # 6ab015e51c823bb5a74a1ec5 one shell over.
        #
        # This shell asked only about the subscription date. It never asked
        # whether the account belongs to the teacher portal at all — so a
        # Login on an ORGANIZATION or SCHOOL account that arrived here went
        # straight to #/teacher_dashboard, and Login.role hands that principal
        # the Login.organization manifest, which holds `qrToken` on Student
        # and nothing else: no group_statistics, no find. teacher.coffee calls
        # both at mount, so the screen was the error boundary (CrashLog
        # 6878a807 on elephantmath, /teacher#/teacher_dashboard).
        #
        # /org is where these accounts already go when they sign in at /app
        # (app-route.coffee), so this is the same answer, applied on the one
        # entry that was not asking. Reproduced on ripper3ws2 2026-09-20 with
        # a planted school account, boundary before and the dashboard after.
        account_type = response.data.login.account?.type
        if account_type in ['organization', 'district', 'school']
          token = window.app.loopbackAPI.accessTokenId
          userId = window.app.loopbackAPI.currentUserId
          theurl = if account_type == 'district' then "/org?access_token=#{token}&uid=#{userId}&masquerade=district" else "/org?access_token=#{token}&uid=#{userId}"
          console.log "#{account_type} account on the teacher portal — its manifest cannot render this shell; opening /org"
          return window.location = if window.app.isAndroid() then window.config.server + theurl else theurl

        # DELIBERATELY STILL A DATE-ONLY TEST, unlike the parent shell's.
        # Login.role gives a teacher account the Login.teacher principal from
        # Account.type whatever its subscription says, so there is no manifest
        # disagreement to close here — and a TRIAL teacher has a future date
        # with a status that is not 'Subscribed'. Swapping in
        # isActiveSubscription for symmetry would send every trial teacher to
        # the billing tab instead of their classroom.
        if moment(response.data.login.account.subscription_end).isAfter(moment())
          if window.app.account.force_onboarding
            window.location = "#/onboarding"
          else
            window.location = routeHash route_to, route_params
        else if moment(response.data.login.account.subscription_end).isBefore(moment())
          if window.app.account.force_onboarding
            window.location = "#/onboarding"
          else
            window.location = '#/account?tab=2'
        else
          window.location.hash = ''
        start_react()
      else
        window.location.hash = ''
    .catch (error) ->
      render_react_error(error)

  window.teacher_mode = true
  window.TitleBar = TitleBar
  if params.access_token? && params.uid? && window.app.loopbackAPI.isLoggedIn()
    window.app.loopbackAPI.clearUser() if window.app.loopbackAPI.currentUserId != params.uid
    window.history.replaceState {}, document.title, "/teacher"
    
  if window.app.loopbackAPI.isLoggedIn() && !(params.new_user == 'true' && params.access_token?)
    if params.access_token? && params.redirectTo?
      # A SERVER-MINTED DEEP LINK ON AN ALREADY-INSTALLED SESSION — card
      # 6aab72ceed72ee7fceb166c3, found by driving the real link on the seat.
      #
      # The `access_token?` branch below is where redirectTo is read, and it is
      # UNREACHABLE for a link that carries a token: the module-scope pre-set
      # further up installs the session before this runs, so isLoggedIn() is
      # already true and control never gets there. Without this branch the link
      # fell to the empty-hash case and opened the default screen — the
      # redirect discarded in silence.
      #
      # Still gated on access_token, per the owner's ruling 2026-09-17.
      initialize params.redirectTo, decodeRedirectParams(params.redirectParams)
    else if !window.location.hash? || window.location.hash is '' || window.location.hash is '#/'
      initialize()
    else
      route = window.location.hash.substring 2
      initialize route
  else if params.access_token?
    window.app.loopbackAPI.setUser(params.access_token, params.uid, undefined, params.studentId)
    window.app.loopbackAPI.resetAuthHeader()
    window.history.replaceState {}, document.title, "/teacher"

    # to avoid variable capture, redirectParams are passed as a separate hash.
    # The PARSED object goes to initialize — passing params.redirectParams here
    # handed it the still-percent-encoded raw string, which the loop in
    # initialize then walked as character indices (card
    # 6aab72ceed72ee7fceb166c3).
    redirectParams = decodeRedirectParams params.redirectParams

    initialize params.redirectTo, redirectParams
  else if window.location.hash != '' and not isUnauthenticatedDeepLink(window.location.hash)
    # A logged-out visitor normally gets dumped at the sign-in screen, so any
    # stale hash is wiped here before the router starts. The reset link is the
    # one deep link that MUST survive that: its whole audience is people who
    # cannot sign in, arriving cold from an email. Blanking the hash here threw
    # the token away before UI-Router ever saw it, and `otherwise` then sent
    # them to the dashboard and on to login — so the emailed link could never
    # work for the only people it is for. Card 6a639e22893d0bbbaaacec81.
    window.location.hash = ''
    start_react()
  else
    start_react()
